import { device } from "shared/constants/device";
import styled from "styled-components";

export const FormGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${device.tablet} { 
    label{
      display:none;
    }
  }
`;
export const FormGroupNotFlex = styled.div`
  label{ 
      width: 100%;
  }
`;
export const FormControl = styled.div`
  input,
  select,
  textarea {
    padding: 5px 10px;
    font-size: 14px;
    width: 100%;
    outline: none;
    border-color: lightgray;
    border-width: 1px;
    border-radius: 5px;
    border-style: solid;
    color: gray;
    &:focus {
      border-color: var(--color-primary);
      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(173, 220, 209, 0.6);
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(173, 220, 209, 0.6);
    }
  }
  @media ${device.tablet} { 
    input,
    select,
    textarea {
      border-top:none;
      border-right:none;
      border-left:none;
      border-radius:0px;
    }
  }
`;

export const FormLabel = styled.label`
  width: 100px;
  margin-right: 10px;
`;
export const FormError = styled.div`
  font-size: 12px;
  color: red;
  margin-left: 5px;
`;
